"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupModerators = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _GroupMemberItem = require("@insided/destination/modules/Groups/GroupMemberItem");

var _GroupMembersWidget = require("@insided/destination/modules/Groups/GroupMembersWidget");

var _service = require("@insided/destination/modules/Groups/service");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_VISIBLE_COUNT = 10;
var DEFAULT_CURRENT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 100;

var GroupModerators = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupModerators, _Component);

  var _super = _createSuper(GroupModerators);

  function GroupModerators() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupModerators);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "userId", (0, _insidedDataStorage.getInsidedData)('user').userid);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showMore: false,
      needShowMore: false,
      moderators: [],
      isLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchMembers();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchMembers", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _yield$fetchMembers, members, total;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              _context2.prev = 1;
              _context2.next = 4;
              return (0, _service.fetchMembers)({
                groupId: _this.props.group.id,
                page: DEFAULT_CURRENT_PAGE,
                pageSize: DEFAULT_PAGE_SIZE,
                filter: _service.fetchMembersFilters.Moderators
              });

            case 4:
              _yield$fetchMembers = _context2.sent;
              members = _yield$fetchMembers.members;
              total = _yield$fetchMembers.total;

              _this.setState({
                moderators: (0, _GroupMembersWidget.mapUsers)(members),
                needShowMore: total > DEFAULT_VISIBLE_COUNT
              });

              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);

              _this.setState({
                isLoading: false
              });

            case 13:
              _this.setState({
                isLoading: false
              });

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onShowMoreSwitch", function () {
      var showMore = _this.state.showMore;

      _this.setState({
        showMore: !showMore
      });
    });
    return _this;
  }

  (0, _createClass2.default)(GroupModerators, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          showMore = _this$state.showMore,
          needShowMore = _this$state.needShowMore,
          moderators = _this$state.moderators,
          isLoading = _this$state.isLoading;
      var moderatorsToShow = showMore ? moderators : moderators.slice(0, DEFAULT_VISIBLE_COUNT);
      return (0, _preact.h)("div", {
        className: "widget group-content-container-moderators"
      }, (0, _preact.h)("h3", {
        className: "widget-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.moderators"
      })), (0, _preact.h)("div", {
        className: "group-content-container-members_member-list groups-v2-styles"
      }, isLoading && !moderators.length ? (0, _preact.h)("div", null, (0, _preact.h)(_GroupMemberItem.GroupMemberSkeleton, {
        isShown: true
      }), (0, _preact.h)(_GroupMemberItem.GroupMemberSkeleton, {
        isShown: true
      })) : null, !isLoading && moderators.length ? moderatorsToShow.map(function (member) {
        return (0, _preact.h)(_GroupMemberItem.GroupMember, {
          key: member.id,
          member: member,
          isWidget: true,
          currentUserId: _this2.userId
        });
      }) : null), (0, _preact.h)(_Button.default, {
        className: (0, _classnames.default)('group-content-container-moderators__more-btn', {
          'is-visible': needShowMore && !showMore
        }),
        title: (0, _preact.h)(_phrase.default, {
          p: "groups.show.more"
        }),
        onClick: this.onShowMoreSwitch,
        size: "medium"
      }), (0, _preact.h)(_Button.default, {
        className: (0, _classnames.default)('group-content-container-moderators__less-btn', {
          'is-visible': needShowMore && showMore
        }),
        title: (0, _preact.h)(_phrase.default, {
          p: "quick.links.show.less"
        }),
        onClick: this.onShowMoreSwitch,
        size: "medium"
      }));
    }
  }]);
  return GroupModerators;
}(_preact.Component);

exports.GroupModerators = GroupModerators;
var _default = GroupModerators;
exports.default = _default;